export default __webpack_public_path__ + "static/media/1037.ec5d2705.png";